import { configureStore } from '@reduxjs/toolkit';
import notificationsReducer from './notificationSlice';
import messagesReducer from './messageSlice';
import userReducer from './userSlice';
import pageHeaderSubtitleReducer from './pageHeaderSubtitleSlice';

const store = configureStore({
  reducer: {
    notifications: notificationsReducer,
    messages: messagesReducer,
    user: userReducer,
    pageHeaderSubtitle: pageHeaderSubtitleReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
